import script from "./HomeDesk.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeDesk.vue?vue&type=script&setup=true&lang=js"

import "./HomeDesk.vue?vue&type=style&index=0&id=6e63f0e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e63f0e6"]])

export default __exports__